import React, { useEffect, useRef, useState } from 'react';
import { connect } from 'react-redux';
import { useBoolean } from '@fluentui/react-hooks';
import { Badge, Button, Text } from '@fluentui/react-components';

// Model imports

// Functions imports
import * as ComponentFunctions from './PractitionerConsumptionToSettle.Functions';
import { formatCurrencyAmount } from '../PractitionerConsumptionCurrency';

// Component imports
import SettlementFormComponent from '../../../Settlements/SettlementForm/Settlement.Form.Component';

// Styles
import './PractitionerConsumptionToSettle.Styles.css';

const PractitionerConsumptionToSettleComponent = (props: ComponentFunctions.Props) => {
    const [isOpen, { setTrue: openPanel, setFalse: dismissPanel }] = useBoolean(false);
    const wrapperRef = useRef<HTMLDivElement | null>(null);
    const [isSticky, setIsSticky] = useState(false);

    useEffect(() => {
        if (props.practitioner?.userId !== undefined) {
            props.GetPractitionerConsumptionsToSettle(props.practitioner.userId);
        }
    }, [props.practitioner?.userId, props.Consumptions?.length]);

    // Sticky detection: toggle is-sticky and publish the strip height so the
    // list toolbar underneath can pin right below it.
    useEffect(() => {
        const el = wrapperRef.current;
        if (!el) return;

        const updateState = () => {
            const stickyOffset = Number.parseFloat(
                getComputedStyle(document.documentElement).getPropertyValue('--page-header-height')
            ) || 56;
            setIsSticky(el.getBoundingClientRect().top <= stickyOffset + 1);
            document.documentElement.style.setProperty(
                '--cts-wrapper-height',
                `${el.getBoundingClientRect().height}px`
            );
        };

        const ro = new ResizeObserver(updateState);
        ro.observe(el);

        updateState();
        window.addEventListener('scroll', updateState, { passive: true });
        return () => {
            ro.disconnect();
            window.removeEventListener('scroll', updateState);
            document.documentElement.style.removeProperty('--cts-wrapper-height');
        };
    }, []);

    const handleClosePanel = () => {
        dismissPanel();
    };

    const Forms = (
        <SettlementFormComponent
            isOpen={isOpen}
            dismissPanel={handleClosePanel}
            openPanel={openPanel}
            ContractId={undefined}
            PractitionerId={props.PractitionerId}
            ProtocolId={undefined}
            MedicalAgreementId={undefined}
            MedicalInsuranceId={undefined}
        />
    );

    return (
        <div ref={wrapperRef} className={`pcts-wrapper${isSticky ? ' is-sticky' : ''}`}>
            <div className="pcts-currencies">
                {props.TotalByCurrency?.length > 0
                    ? props.TotalByCurrency.map((total) => (
                        <div key={total.Currency} className="pcts-total-item">
                            <Badge appearance="filled" color="brand">
                                {(total.Currency || '—').toUpperCase()}
                            </Badge>
                            <div className="pcts-total-block">
                                <span className="pcts-total-label">Total a liquidar</span>
                                <Text size={500} weight="semibold">
                                    {formatCurrencyAmount(total.Total, total.Currency)}
                                </Text>
                            </div>
                        </div>
                    ))
                    : <span className="pcts-empty">Sin consumos a liquidar</span>}
            </div>

            <div className="pcts-actions">
                <Button appearance="primary" onClick={openPanel}>
                    Generar Liquidación&nbsp;<Badge>{props.Consumptions.length}</Badge>
                </Button>
            </div>

            {Forms}
        </div>
    );
};

export default connect(
    ComponentFunctions.mapStateToProps,
    ComponentFunctions.mapDispatchToProps
)(PractitionerConsumptionToSettleComponent as any);
